module.exports = __webpack_public_path__ + "static/media/hot53.ed3a343c.jpg";